import { render, staticRenderFns } from "./micoapp.vue?vue&type=template&id=27699a18&scoped=true"
import script from "./micoapp.vue?vue&type=script&lang=js"
export * from "./micoapp.vue?vue&type=script&lang=js"
import style0 from "./micoapp.vue?vue&type=style&index=0&id=27699a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27699a18",
  null
  
)

export default component.exports